import logo from './logo.svg';
import './App.css';

function App() {

  let posts = '강남 우동 맛집';

  return (
    <div className="App">
      <div className="container">  {/* Changed 'class' to 'className' */}
        <h4 id={posts}>React App</h4>
        <p>React App with Docker</p>
      </div>
      <h4 style={{ color: 'red' }}>{posts}</h4>

      <img src={logo} className="App-logo" alt="logo" />
    </div>
  );
}

export default App;
